import { cn } from "@/lib/utils";

function PoiDetailsImage({ showMore }: { showMore: boolean }) {
  return <div className={cn("lg:h-16", showMore && "h-16")}></div>;
}

export default PoiDetailsImage;
